import { isAxiosError } from 'axios';
import HttpClient from '../HttpClient';
import HTTPResponse from '../HttpResponse';

class Status {
  private http: HttpClient;

  public constructor(http: HttpClient) {
    this.http = http;
  }

  public getStatus = async (): Promise<HTTPResponse<string>> => {
    let res = '';
    try {
      const result = await this.http.get<string>('/greeting');
      res = result.data;
      return new HTTPResponse(res);
    } catch (err) {
      if (isAxiosError(err)) {
        const { response } = err;
        return new HTTPResponse(res, response);
      }
      return new HTTPResponse(res);
    }
  };
}

export default Status;
